import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { connect } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { Spinner } from '@pijma/crypto'

import { topupApplicationClient } from '@api'
import { EPaymentMethod, TFailureResponse } from '@api/types'
import { Dispatch, RootState } from '@stores'
import { TPayFormState } from '@stores/types/*'
import { HttpStatusCode } from 'axios'
import styled from 'styled-components'

import { EOperationErrorCause } from '../../../../api/types/EOperationErrorCause'
import { EPaymentProvider } from '../../../../stores/types/EPaymentProvider'
import { H4 } from '../../../common/header/Headings'
import { FlexBoxCenteredLayout } from '../../../common/layout/flex-box'

const Container = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 100%;
  margin-top: -80px;
`

const TitleWrapper = styled.div`
  margin-top: 16px;
  white-space: pre-wrap;
`

interface StateProps {
  payForm: TPayFormState
}

interface DispatchProps {
  doPaymentBlocking: () => void
  resetPaymentBlocking: () => void
}

type Props = StateProps & DispatchProps

function makeFormAndSubmit(
  redirectUrl: string,
  params: { [key: string]: string },
) {
  const form = document.createElement('form')
  form.action = redirectUrl
  form.method = 'post'
  form.style.display = 'none'

  Object.entries(params).forEach(([key, value]) => {
    const input = document.createElement('input')
    input.type = 'hidden'
    input.name = key
    input.value = value
    form.append(input)
  })

  document.body.append(form)
  form.submit()
}

const FindPurchaseOffersPage = (props: Props) => {
  const intl = useIntl()
  const redirectTo = useNavigate()
  const applicationId = props.payForm?.application?.applicationUuid as string

  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  const catchReason = (reason: any) => {
    props.resetPaymentBlocking()
    const failureResponse = reason.response.data as TFailureResponse
    if (
      failureResponse.errorCode === EOperationErrorCause.NO_OFFERS_AVAILABLE
    ) {
      redirectTo(`../../application/${applicationId}/purchase/offers-not-found`)
      return
    }
    console.log('something going wrong with payment', reason)
    if (reason.response.status === HttpStatusCode.Unauthorized) {
      redirectTo(`../../timeout`)
    } else {
      redirectTo(`../../failure`)
    }
  }

  useEffect(
    () => {
      if (!props.payForm.application?.applicationUuid)
        throw 'no applicationUuid'
      if (!props.payForm.amountFrom) throw 'no amountFrom'
      if (!props.payForm.amountTo) throw 'no amountTo'
      if (!props.payForm.paymentGateway) throw 'no gateway'
      if (!props.payForm.paymentGateway.paymentGatewayId)
        throw 'no paymentGatewayId'
      props.doPaymentBlocking()

      topupApplicationClient
        .topup(
          props.payForm.application.applicationUuid,
          props.payForm.amountFrom,
          props.payForm.amountTo,
          props.payForm.paymentGateway.paymentGatewayId,
          props.payForm.sender,
          props.payForm.senderFullName,
          props.payForm.phone,
          props.payForm.last4pan,
        )
        .then((res) => {
          if (
            props.payForm.paymentGateway?.provider === EPaymentProvider.SPAYZ
          ) {
            makeFormAndSubmit(res.redirectUrl, res.params)
          } else {
            window.location.replace(res.redirectUrl)
          }
        })
        .catch((reason) => catchReason(reason))
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  )

  const title =
    props.payForm.paymentGateway?.paymentMethod ==
    EPaymentMethod.BANK_CARD ? null : (
      <TitleWrapper>
        <H4>{intl.formatMessage({ id: 'findPurchaseOffersPage.title' })}</H4>
      </TitleWrapper>
    )

  return (
    <FlexBoxCenteredLayout>
      <Container>
        <Spinner size={24} />

        {title}
      </Container>
    </FlexBoxCenteredLayout>
  )
}

const mapStateToProps = (state: RootState): StateProps => ({
  payForm: state.payForm,
})

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => {
  return {
    doPaymentBlocking: () =>
      dispatch.payForm.set({
        paymentBlocking: true,
      }),
    resetPaymentBlocking: () =>
      dispatch.payForm.set({
        paymentBlocking: false,
      }),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FindPurchaseOffersPage)
